import { LinearProgress } from "@mui/material";
import { withStyles } from "tss-react/mui";

import { colors } from "@/theme/overrides/colors";

const TransparentProgress = withStyles(LinearProgress, {
  root: {
    height: 4,
    width: "100%",
    backgroundColor: colors.grayLightest,
  },
  bar: {
    backgroundColor: colors.primary,
    transition: "transform 0.3s ease",
  },
});

export default TransparentProgress;
